import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  warning?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, required, value, defaultValue, warning, ...props },
    ref,
  ) => {
    const isControlled = value !== undefined;
    const currentValue = isControlled ? value : defaultValue;
    const isEmpty = !currentValue || currentValue.toString().trim() === "";
    const shouldHighlight = required && isEmpty;

    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        required={required}
        {...(isControlled ? { value } : { defaultValue })}
        className={cn(
          "file:text-foreground bg-background font-light placeholder:text-muted-foreground placeholder:text-sm selection:bg-primary selection:text-primary-foreground border-ring/50 dark:bg-input/50 flex h-control w-full min-w-0 rounded-md border px-2.5 py-1 text-control shadow-[0_2px_6px_rgba(0,0,0,0.06)] hover:shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_2px_6px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_3px_10px_rgba(0,0,0,0.12)] transition-all outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 opacity-70 focus-visible:opacity-100",
          "focus-visible:ring-ring/30 focus-visible:ring-1",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          shouldHighlight && "border-primary/50 ring-primary/50",
          warning &&
            "border-yellow-500 ring-yellow-500/20 ring-1 dark:border-yellow-600 dark:ring-yellow-600/20",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
